import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error module not typed
import EmailAddressPattern from 'PatternValidationJS/patterns/EmailAddress';
import { CONTACT_TYPE_ID, fetchEmailContacts } from '../api/crmSearchApi';
import formatName from 'I18n/utils/formatName';
import { convertToHtml } from 'hubspot-prosemirror/prosemirror/ProsemirrorUtils';
import { CANDY_APPLE } from 'HubStyleTokens/colors';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { trackInteraction } from '../usage-tracker/track';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const getPersonalEmailsFromInboxes = connectedInboxes => {
  return connectedInboxes.filter(inbox => (inbox.inboxStatus === 'ENABLED' || inbox.inboxStatus === 'INACTIVE') && !inbox.shared).map(inbox => {
    const primaryAlias = inbox.aliases.find(alias => alias.primary);
    const {
      sendFromEmail,
      resolvedFromName = null,
      conversationsInboxName = null
    } = primaryAlias || {};
    return {
      email: sendFromEmail || inbox.accountId,
      accountId: inbox.accountId,
      disabled: inbox.inboxStatus === 'INACTIVE',
      shared: inbox.shared,
      name: resolvedFromName,
      conversationsInboxName
    };
  });
};
export const getTeamEmailsFromAccounts = (connectedAccounts, defaultEmail) => {
  return connectedAccounts.filter(account => !account.isDefault && (account.userAllowedAccess || account.email === defaultEmail)).map(account => {
    var _account$resolvedFrom;
    return {
      email: account.sendFromEmail || account.email,
      accountId: account.email,
      disabled: !account.isActive,
      shared: true,
      name: (_account$resolvedFrom = account.resolvedFromName) !== null && _account$resolvedFrom !== void 0 ? _account$resolvedFrom : null,
      conversationsInboxName: account.conversationsInboxName
    };
  });
};
const getEmailOptionDisplayValue = ({
  name,
  email
}) => {
  if (name && email) return `${name} (${email})`;
  if (email) return email;
  return name || '';
};
const getHelpTextFromEmail = email => {
  if (email.shared) {
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      "data-test-id": "team-email-help-text",
      children: [/*#__PURE__*/_jsx(Text, {
        color: "text-core-default",
        as: "small",
        children: /*#__PURE__*/_jsx(TruncateString, {
          children: email.conversationsInboxName
        })
      }), email.disabled && /*#__PURE__*/_jsx(Text, {
        use: "help",
        as: "small",
        children: /*#__PURE__*/_jsx(TruncateString, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "CommerceToolsUiLib.shareToolModal.emailTab.fromField.optionHelpText.teamEmailDisabled"
          })
        })
      })]
    });
  }
  if (email.disabled) {
    return /*#__PURE__*/_jsx(Flex, {
      marginBlockEnd: "200",
      flexDirection: "column",
      children: /*#__PURE__*/_jsx(TruncateString, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "CommerceToolsUiLib.shareToolModal.emailTab.fromField.optionHelpText.personalEmailDisabled"
        })
      })
    });
  }
  return undefined;
};
const groupEmails = (emails, isShared, subheaderKey) => {
  const filteredEmails = emails.filter(({
    shared
  }) => shared === isShared);
  if (filteredEmails.length === 0) return null;
  return {
    text: I18n.text(subheaderKey),
    options: filteredEmails.map(email => ({
      text: getEmailOptionDisplayValue({
        name: email.name,
        email: email.email
      }),
      value: email.email,
      icon: email.disabled ? 'warning' : undefined,
      iconColor: CANDY_APPLE,
      help: getHelpTextFromEmail(email)
    }))
  };
};
export const getSelectOptionsFromEmails = connectedEmails => {
  return [groupEmails(connectedEmails, false, 'CommerceToolsUiLib.shareToolModal.emailTab.fromField.personalEmailsSubheader'), groupEmails(connectedEmails, true, 'CommerceToolsUiLib.shareToolModal.emailTab.fromField.teamEmailsSubheader')].filter(option => option !== null);
};
const INBOX_SETTINGS_URL = `${getFullUrl('app')}/live-messages-settings/${PortalIdParser.get()}/inboxes`;
const EMAIL_SETTINGS_URL = `${getFullUrl('app')}/settings/${PortalIdParser.get()}/user-preferences/email`;
export const getFromFieldValidationMessage = selectedFromValue => {
  const personalEmailDisabled = selectedFromValue.disabled && !selectedFromValue.shared;
  const teamEmailDisabled = selectedFromValue.disabled && selectedFromValue.shared;
  switch (true) {
    case personalEmailDisabled:
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "CommerceToolsUiLib.shareToolModal.emailTab.fromField.validationMessage.personalEmailDisabled_jsx",
        elements: {
          UILink: Link,
          br: 'br'
        },
        options: {
          href: EMAIL_SETTINGS_URL,
          external: true,
          onClick: () => {
            trackInteraction({
              action: 'click manage connected personal email connections link'
            });
          }
        }
      });
    case teamEmailDisabled:
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "CommerceToolsUiLib.shareToolModal.emailTab.fromField.validationMessage.teamEmailDisabled_jsx",
        elements: {
          UILink: Link,
          br: 'br'
        },
        options: {
          href: INBOX_SETTINGS_URL,
          external: true,
          onClick: () => {
            trackInteraction({
              action: 'click manage connected team email connections link'
            });
          }
        }
      });
    default:
      return null;
  }
};
export const isValidEmail = email => {
  return EmailAddressPattern.test(email);
};
export const getEmailContactValue = contact => {
  var _contact$properties$e;
  return (contact === null || contact === void 0 ? void 0 : contact.objectId) || (contact === null || contact === void 0 || (_contact$properties$e = contact.properties.email) === null || _contact$properties$e === void 0 ? void 0 : _contact$properties$e.value);
};
const isTooManyContacts = (selectedCcValues, selectedToValue) => {
  const totalContacts = selectedCcValues.length + (selectedToValue ? 1 : 0);
  return totalContacts > 10;
};
export const getToFieldValidationMessage = (selectedToValue, selectedCcValues) => {
  var _selectedToValue$prop, _selectedToValue$prop2;
  if (!selectedToValue) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CommerceToolsUiLib.shareToolModal.emailTab.toField.validationMessage.missingContact"
    });
  }
  if (!isValidEmail((_selectedToValue$prop = (_selectedToValue$prop2 = selectedToValue.properties.email) === null || _selectedToValue$prop2 === void 0 ? void 0 : _selectedToValue$prop2.value) !== null && _selectedToValue$prop !== void 0 ? _selectedToValue$prop : '')) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CommerceToolsUiLib.shareToolModal.emailTab.toField.validationMessage.email"
    });
  }
  if (isTooManyContacts(selectedCcValues, selectedToValue)) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CommerceToolsUiLib.shareToolModal.emailTab.allFields.validationMessage.max"
    });
  }
  return null;
};
export const getCcFieldValidationMessage = (selectedCcValues, selectedToValue) => {
  const invalidEmails = !selectedCcValues.every(value => {
    var _value$properties$ema, _value$properties$ema2;
    return isValidEmail((_value$properties$ema = (_value$properties$ema2 = value.properties.email) === null || _value$properties$ema2 === void 0 ? void 0 : _value$properties$ema2.value) !== null && _value$properties$ema !== void 0 ? _value$properties$ema : '');
  });
  const tooManyContacts = isTooManyContacts(selectedCcValues, selectedToValue);
  switch (true) {
    case invalidEmails:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CommerceToolsUiLib.shareToolModal.emailTab.ccField.validationMessage.email"
      });
    case tooManyContacts:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CommerceToolsUiLib.shareToolModal.emailTab.allFields.validationMessage.max"
      });
    default:
      return null;
  }
};
export const getNewEmailContact = value => ({
  objectId: null,
  objectTypeId: CONTACT_TYPE_ID,
  properties: {
    email: {
      name: 'email',
      value
    }
  },
  portalId: PortalIdParser.get()
});
const getHelpTextFromContact = contact => {
  var _contact$properties$e2;
  const email = (_contact$properties$e2 = contact.properties.email) === null || _contact$properties$e2 === void 0 ? void 0 : _contact$properties$e2.value;
  let message;
  if (!email) {
    message = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CommerceToolsUiLib.shareToolModal.emailTab.toField.optionHelpText.emptyEmail"
    });
  } else if (!isValidEmail(email)) {
    message = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CommerceToolsUiLib.shareToolModal.emailTab.toField.optionHelpText.invalidEmail"
    });
  }
  if (message) {
    return /*#__PURE__*/_jsx(Flex, {
      marginBlockEnd: "200",
      flexDirection: "column",
      children: /*#__PURE__*/_jsx(TruncateString, {
        children: message
      })
    });
  }
  return undefined;
};
export const getSelectOptionsFromContacts = contacts => {
  return contacts.map(contact => {
    var _contact$properties$e3, _contact$properties$e4, _contact$properties$f, _contact$properties$l;
    const email = (_contact$properties$e3 = (_contact$properties$e4 = contact.properties.email) === null || _contact$properties$e4 === void 0 ? void 0 : _contact$properties$e4.value) !== null && _contact$properties$e3 !== void 0 ? _contact$properties$e3 : '';
    const name = formatName({
      firstName: (_contact$properties$f = contact.properties.firstname) === null || _contact$properties$f === void 0 ? void 0 : _contact$properties$f.value,
      lastName: (_contact$properties$l = contact.properties.lastname) === null || _contact$properties$l === void 0 ? void 0 : _contact$properties$l.value
    });
    const text = getEmailOptionDisplayValue({
      name,
      email
    });
    const value = contact.objectId || email;
    const shouldShowWarning = !email || !isValidEmail(email);
    return {
      text,
      value,
      record: contact,
      tagUse: shouldShowWarning ? 'danger' : undefined,
      icon: shouldShowWarning ? 'warning' : undefined,
      iconColor: CANDY_APPLE,
      help: getHelpTextFromContact(contact)
    };
  });
};
export const getEmailContactLoadOptions = () => {
  return (input, callback) => {
    if (!input.length) {
      callback(null);
      return;
    }
    fetchEmailContacts(input).then(contacts => {
      const sanitizedInput = input.trim();
      const shouldShowWarning = !isValidEmail(sanitizedInput);
      const doesInputMatchContact = Boolean(contacts.find(contact => contact.properties.email && contact.properties.email.value.toLowerCase() === sanitizedInput));
      const contactOptions = getSelectOptionsFromContacts(contacts);
      if (!doesInputMatchContact) {
        const newEmailContact = getNewEmailContact(sanitizedInput);
        contactOptions.push({
          text: sanitizedInput,
          value: sanitizedInput,
          record: newEmailContact,
          tagUse: shouldShowWarning ? 'danger' : undefined,
          icon: shouldShowWarning ? 'warning' : undefined,
          iconColor: CANDY_APPLE,
          help: getHelpTextFromContact(newEmailContact)
        });
      }
      callback(null, {
        options: contactOptions
      });
    }).catch(() => {});
  };
};
export const MAX_SUBJECT_LENGTH = 100;
export const MAX_BODY_LENGTH = 5000;
export const getSubjectFieldValidationMessage = subjectValue => {
  if (subjectValue.length > MAX_SUBJECT_LENGTH) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CommerceToolsUiLib.shareToolModal.emailTab.subjectField.validationMessage.maxCharacters",
      options: {
        maxLength: MAX_SUBJECT_LENGTH
      }
    });
  }
  return null;
};
export const getBodyFieldValidationMessage = bodyValue => {
  if (bodyValue.length > MAX_BODY_LENGTH) {
    return /*#__PURE__*/_jsxs(Flex, {
      children: [/*#__PURE__*/_jsx(Text, {
        color: "text-alert-default",
        as: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "CommerceToolsUiLib.shareToolModal.emailTab.bodyField.validationMessage.maxCharacters",
          options: {
            maxLength: MAX_BODY_LENGTH
          }
        })
      }), /*#__PURE__*/_jsx(Flex, {
        justifyContent: "end",
        children: /*#__PURE__*/_jsx(Text, {
          as: "small",
          children: MAX_BODY_LENGTH - bodyValue.length
        })
      })]
    });
  }
  return null;
};
export const getEditorText = editorState => convertToHtml(editorState);